import api from "./axios";

export const referFriend = async (payload) => {
  const response = await api.post("/users/refer-code/", payload);
  return response.data;
};

export const getCoupons = async () => {
  const response = await api.get("subscriptions/coupon-codes/");
  return response.data;
};

export const getRewards = async () => {
  const response = await api.get("users/rewards/");
  return response.data;
};
